<template>
    <div>

        <select-pay-section-component
                single
                :dialog="pay_section_dialog"
                :selected="selected_pay_section"
                @save="set_pay_section"
                @close="close_pay_section_dialog"
        ></select-pay-section-component>

        <v-text-field
                :value="codeLabel"
                :label="label"
                :disabled="disabled"
                outlined
                dense
                hide-details="auto"
                :color="inputColor"
                :background-color="backgroundColor"
                @click="readonly ? null : pay_section_dialog = true"
                readonly
                :clearable="!(readonly || notClearable)"
                @click:clear="clear"
                :rules="rules"
        ></v-text-field>
        <input type="hidden"/>


    </div>
</template>

<script>
import {usePaySectionStore} from "@/stores/PaySection";
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        value: String,
        label: String,
        disabled: Boolean,
        readonly: Boolean,
        notClearable: Boolean,
        rules: Array,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();

        const paySectionStore = usePaySectionStore();

        const pay_section_dialog = ref(false);
        const selected_pay_section = ref([]);
        const codeLabel = ref(null);

        function set_code_label(code) {
            const matchingPaySection = paySectionStore.paySections.find(element => element.code === code);
            codeLabel.value = `[${matchingPaySection.code}] ${matchingPaySection.label}`;
        }

        function set_pay_section() {
            if (selected_pay_section.value.length > 0) {
                codeLabel.value = selected_pay_section.value[0].codeLabel;
                emit("input", selected_pay_section.value[0].code);
                pay_section_dialog.value = false;
            }
            selected_pay_section.value = [];
        }

        function close_pay_section_dialog() {
            pay_section_dialog.value = false;
        }

        function clear() {
            codeLabel.value = null;
            emit("input", null);
        }

        watch(() => props.value, () => {
            if (props.value)
                set_code_label(props.value);
        }, {immediate: true});

        return {
            paySectionStore,
            inputColor,
            backgroundColor,
            pay_section_dialog,
            selected_pay_section,
            codeLabel,
            set_pay_section,
            close_pay_section_dialog,
            clear,
        }
    },
};
</script>